<template>
  <v-dialog v-model="dialog" width="500">
    <template v-slot:activator="{ attrs }">
      <v-btn
        color="primary"
        dark
        class="mb-2"
        v-bind="attrs"
        v-on:click="openSetting()"
      >
      </v-btn>
    </template>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-card>
        <v-card-title>
          <span class="text-h5">個人設定頁</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-col>
              <v-text-field
                hide-details="auto"
                label="帳號"
                v-model="desserts.account"
                required
                :rules="rules.account"
                placeholder="請輸入使用者帳號"
              >
              </v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                label="密碼"
                :rules="rules.password.concat(passwordConfirmationRule)"
                v-model="desserts.password"
                required
                placeholder="請輸入密碼，最少4個字元"
              >
              </v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                label="確認密碼"
                v-model="desserts.confirmPassword"
                :rules="rules.confirmPassword.concat(passwordConfirmationRule)"
                required
                placeholder="請再次輸入密碼"
              >
              </v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                label="使用者名稱"
                v-model="desserts.name"
                placeholder="請輸入使用者名稱"
              >
              </v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                label="郵件地址"
                v-model="desserts.email"
                placeholder="請輸入郵件地址"
                :rules="rules.email"
              >
              </v-text-field>
            </v-col>
            <v-radio-group v-model="desserts.authLevel" mandatory disabled row>
              <v-subheader>角色:</v-subheader>
              <v-radio label="使用者" :value="10"></v-radio>

              <v-radio label="管理員" :value="255"></v-radio>
            </v-radio-group>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="save">
            I accept
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import swal from "sweetalert2";

export default {
  props: {
    inputValue: Boolean,
  },
  data: () => ({
    dialog: false,
    desserts: [],
    rules: {
      account: [
        (value) => !!value || "Required",
        (value) => (value && value.length >= 4) || "Min 4 characters",
      ],
      password: [
        (value) => !!value || "Required",
        (value) => (value && value.length >= 4) || "Min 4 characters",
      ],

      confirmPassword: [
        (value) => !!value || "Required",
        (value) => (value && value.length >= 4) || "Min 4 characters",
      ],
      email: [
        (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      ],
    },
  }),
  methods: {
    ...mapActions(["editUser", "getUserByToken", "checkAccount"]),
    openSetting() {
      this.$store
        .dispatch("getUserByToken", {
          token: this.$cookies.get("token"),
          checkSelf: true,
        })
        .then(() => {
          this.desserts = this.getUser;
          // this.desserts.confirmPassword = this.desserts.password;
        });

      this.dialog = true;
    },
    save() {
      console.log(this.$refs.form.validate());
      if (this.$refs.form.validate() == true) {
        this.editedItem = Object.assign({}, this.desserts);
        this.editedItem["token"] = this.$cookies.get("token");
        this.$store.dispatch("checkAccount", this.editedItem).then(() => {
          if (this.getAccountFlag) {
            this.$store.dispatch("editUser", this.editedItem);
            this.dialog = false;
          } else {
            swal.fire({
              icon: "warning",
              title: "帳號重複請重新更改",
            });
          }
        });
      } else {
        swal.fire({
          icon: "warning",
          title: "請確認密碼或格式是否相符",
        });
      }
    },
  },
  computed: {
    ...mapGetters(["getMembers", "getUser", "getAccountFlag"]),
    passwordConfirmationRule() {
      return () =>
        this.desserts.password === this.desserts.confirmPassword ||
        "Password must match";
    },
  },
};
</script>
